module.exports = __webpack_public_path__ + "static/img/tpl-insurance.e0cbbcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/tpl-insurance.png
// module id = RrkZ
// module chunks = 1